module.exports = "https://coursera_assets.s3.amazonaws.com/images/0a25da2281385306408e5a146a4be965.png";